module.exports = __webpack_public_path__ + "img/downloads-zip.1310fc20.svg";